import React from 'react';
import { UserAuth } from '../../context/AuthContext';
import x from '../../assets/icons/x.svg';
import ro from '../../locales/ro.json';
import './Navigation.css';

function Navbar() {
    const [navState, setNavState] = React.useState(false);
    const { logOut, user } = UserAuth();

    const handleSignOut = async () => {
        try {
            await logOut();
            window.location.assign("/login");
        } catch (error) {
            console.log(error);
        }
    };

    const activateNavbar = () => {
        setNavState(!navState);
    };

    const populateContent = () => {
        return ro.navbar.items.map((item, key) => {
            if (!item.inProduction && !user.isAdmin) return null;

            if (user.isAdmin === false && item.isAdmin === true) return null;

            let action;
            if (item.action === "logout") action = handleSignOut;
            else action = () => window.location.assign(item.action);

            return (
                <div key={key} className="nav-item-wrapper" onClick={action}>
                    <img className="nav-item-icon" src={item.icon} alt={item.name} />
                </div>
            );
        });
    };

    return (
        <div>
            {user.isPreviouslyAuthenticated === undefined ? (
                <div className={"nav-wrapper" + (navState ? " nav-wrapper-open" : "")}>
                    <div className={navState ? "nav-photo-wrapper" : ""}>
                        <img
                            className={"nav-user-photo" + (navState ? " nav-user-open" : "")}
                            src={user.photoURL}
                            onClick={activateNavbar}
                            referrerPolicy="no-referrer"
                            alt="User"
                        />
                        {navState ? (
                            <div className="nav-blur-background" onClick={() => setNavState(false)}></div>
                        ) : null}
                    </div>

                    <div style={{ display: navState ? null : "none" }}>
                        {populateContent(user)}
                    </div>
                </div>
            ) : null}
        </div>
    );
}

export default Navbar;